import { inject, Injectable } from "@angular/core";
import { UserService } from "./user.service";
import { filter, map, Observable } from "rxjs";
import { toSignal } from "@angular/core/rxjs-interop";
import { UserPermission } from "../enums/permission.enum";

@Injectable()
export class RolePermissionService {
  // private auth = inject(AuthService);
  // TODO: Should the roles/permissions be fetched separately from the user info and handled by authService?

  private userService = inject(UserService);

  public readonly hasAdminAccess$ = this.hasPermission(
    UserPermission.AdminAccess
  );
  public readonly hasCoreMemberAccess$ = this.hasPermission(
    UserPermission.CoreMemberAccess
  );
  public readonly hasCapgeminiAccess$ = this.hasPermission(
    UserPermission.CapgeminiAccess
  );
  public readonly hasUserAccess$ = this.hasPermission(
    UserPermission.UserAccess
  );
  private readonly isAnonymous$ = this.userService.userInfo$.pipe(
    map((user) => !user?.permissions || user.permissions.length === 0)
  );

  public readonly hasAdminAccess = toSignal(this.hasAdminAccess$);
  public readonly hasCoreMemberAccess = toSignal(this.hasCoreMemberAccess$);
  public readonly hasCapgeminiAccess = toSignal(this.hasCapgeminiAccess$);
  public readonly hasUserAccess = toSignal(this.hasUserAccess$);
  public readonly isAnonymous = toSignal(this.isAnonymous$);

  private hasPermission(permission: UserPermission): Observable<boolean> {
    return this.userService.userInfo$.pipe(
      map((user) => !!user?.permissions?.includes(permission) || false)
    );
  }
}
